// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3wkXk","col":"Table_col__ivYSR","fulfillmentStatus":"Table_fulfillmentStatus__yOyDV","emailCol":"Table_emailCol__2YgnB"};